module.exports = __webpack_public_path__ + "img/auth2.feb45a9e.png";